import ActivityModalType from "../Datasets/activity_modal_type";

export const determineActivityModalType = (activityType, friendName) => {
    let modalSize = "";
    let modalClass = "";
    const modalObj = ActivityModalType.find(elem => elem.activityType === activityType);
    if (modalObj){
        if (friendName){
            modalSize = modalObj.withFriend;
        }else{
            modalSize = modalObj.noFriend;
        }
        if (modalObj.modalClass){
            modalClass = modalObj.modalClass;
        }
    }
    return {modalSize: modalSize, modalClass: modalClass};
}
export default determineActivityModalType;